module.exports = __webpack_public_path__ + "img/ic-screens-inactive.338e8c3f.svg";